import { ActionContext } from 'vuex';
import * as auth from '@/helpers/auth';

export type AuthState = {
  loading: boolean;
  signinError: Error | undefined;
  signupError: Error | undefined;
};

export default {
  state: {
    loading: false,
    signinError: undefined,
    signupError: undefined,
  },
  actions: {
    async signIn(
      context: ActionContext<AuthState, any>,
      { email, password, rememberMe, }: { email: string; password: string; rememberMe: boolean; },
    ) {
      context.commit('startLoadingAuth');
      try {
        const user = await auth.signIn(email, password, rememberMe);
        context.commit('signInSucceeded', user);
      } catch (e) {
        context.commit('signInFailed');
        context.commit('signinError', { error: e });
      } finally {
        context.commit('stopLoadingAuth');
      }
    },
    async signUp(
      context: ActionContext<AuthState, any>,
      {
        firstName,
        lastName,
        email,
        password,
        invitationCode,
        locale,
      }: {
        email: string;
        password: string;
        firstName: string;
        lastName: string;
        invitationCode: string | undefined;
        locale: string;
      },
    ) {
      context.commit('startLoadingAuth');
      try {
        const user = await auth.signUp(firstName, lastName, email, password, invitationCode, locale);
        context.commit('signUpSucceeded', user);
      } catch (e) {
        context.commit('signUpFailed');
        context.commit('signupError', { error: e });
      } finally {
        context.commit('stopLoadingAuth');
      }
    },
    async signOut(context: ActionContext<AuthState, any>) {
      context.commit('startLoadingAuth');
      try {
        await auth.signOut();
        context.commit('logoutCompleted');
      } finally {
        context.commit('stopLoadingAuth');
      }
    },
  },
  mutations: {
    startLoadingAuth(state: AuthState) {
      state.loading = true;
      state.signinError = undefined;
      state.signupError = undefined;
    },
    stopLoadingAuth(state: AuthState) {
      state.loading = false;
    },
    signinError(state: AuthState, { error }: { error: Error }) {
      state.signinError = error;
    },
    signupError(state: AuthState, { error }: { error: Error }) {
      state.signupError = error;
    },
  },
};
